import React from "react";
import { Grid } from "@material-ui/core";
import { Input, Select } from "@rocketseat/unform";
import * as CONSTANTS from "../../services/constants";

export default function EmployeeFields(props) {
  return (
    <div>
      <Grid container spacing={3} overflow="hidden">
        <Grid item xs={12} sm={6}>
          <Input
            name="name"
            id="name"
            placeholder={CONSTANTS.placeholders.nome}
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Input
            name="birthDate"
            placeholder={CONSTANTS.placeholders.dataNascimento}
            data-mask="99/99/9999"
            id="birthDate"
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Input
            name="cpf"
            placeholder={CONSTANTS.placeholders.cpf}
            data-mask="999.999.999-99"
            id="cpf"
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Input
            id="rg"
            name="rg"
            className="form-control m-1"
            placeholder={CONSTANTS.placeholders.rg}
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Input
            id="phone"
            name="phone"
            placeholder={CONSTANTS.placeholders.telefone}
            className="form-control m-1"
            data-mask="(99) 9999-9999?9"
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Select
            name="SectorId"
            placeholder={CONSTANTS.placeholders.setor}
            className="custom-select form-control m-1 "
            options={props.sectors}
            required
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Select
            name="FunctionId"
            placeholder={CONSTANTS.placeholders.funcao}
            className="custom-select form-control m-1"
            options={props.functions}
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <Input
            id="functionDescription"
            name="functionDescription"
            placeholder={CONSTANTS.placeholders.funcaoOutros}
            className="form-control m-1"
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Input
            id="email"
            placeholder={CONSTANTS.placeholders.email}
            name="email"
            className="form-control m-1"
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Input
            id="country"
            name="country"
            placeholder={CONSTANTS.placeholders.pais}
            className="form-control  m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Select
            name="state"
            placeholder={CONSTANTS.placeholders.estado}
            className="custom-select form-control m-1"
            options={props.states}
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <Input
            id="city"
            name="city"
            placeholder={CONSTANTS.placeholders.cidade}
            className="form-control  m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Input
            id="district"
            name="district"
            placeholder={CONSTANTS.placeholders.bairro}
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Input
            id="address"
            name="address"
            placeholder={CONSTANTS.placeholders.endereço}
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <Input
            id="number"
            name="number"
            placeholder={CONSTANTS.placeholders.numero}
            className="form-control m-1"
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <Input
            id="complement"
            name="complement"
            placeholder={CONSTANTS.placeholders.complemento}
            className="form-control m-1"
          />
        </Grid>
      </Grid>
    </div>
  );
}
